import { TOffer } from "pages/Search/Offer";

import { axiosInstance2, axiosInstance } from "./api";

export const suggestion = async ({ search }: { search: string }) => {
  const res = await axiosInstance2.get(`/v3/suggestion/${search}`);
  return res.data;
};

export type TBrand = {
  brand: string;
  name: string;
  partNumber: string;
};

export type TProductSearchValue = {
  name: string;
  nomenclatureId: string;
  offer: TOffer[];
  shownMore?: number;
  image?: string;
  certificate?: string;
};

export type TBrandSearch = {
  [key: string]: TProductSearch;
};

export type TProductSearch = {
  [key: string]: TProductSearchValue;
};

export type TProductSearchArray = [string, TProductSearchValue];

export type TBrandSearchArray = [string, TProductSearch];
export interface ISearchResult {
  data: TBrandSearch;
  info: {
    partNumber: string;
    brand: string;
    image?: string;
    nomenclatureId?: string;
  };
  bestOffers: {};
  group?: []
};

export interface IQuery {
  article: string;
  brand?: string | null;
  userId: string;
  provider?: string;
};

// export const searchAPI = createApi({
//   reducerPath: "searchAPI",
//   baseQuery: fetchBaseQuery({ baseUrl: baseUrl2 }),
//   endpoints: (build) => ({
//     fetchAllSearch: build.query<ISearchResult, IQuery>({
//       query: ({ article, brand, userId, provider = "" }) => {

//         return {
//           url: brand
//             ? `/v3/search/${article}/${brand}`
//             : `/v3/search/${article}`,
//           params: {
//             uid: userId,
//             provider
//           }
//         };
//       }
//     })
//   })
// });

// export const searchPrice = async ({
//   article,
//   brand,
//   userId,
//   provider = ""
// }: {
//   article: string;
//   brand?: string | null;
//   userId?: string;
//   provider?: string;
// }) => {
//   const url = brand
//     ? `/v3/search/${article}/${brand}`
//     : `/v3/search/${article}`;

//   const res = await axiosInstance2.get(url, {
//     params: {
//       uid: userId,
//       provider
//     }
//   });
//   return res.data;
// };

/**
 * Клиентская карточка номенклатуры (lider-client-new).
 * GET /api/v2/nomenclature/client/{id} — заменяет legacy /nomenclature.getOneClient.
 */
export const NOMENCLATURE_CLIENT_V2_BASE = "/api/v2/nomenclature/client";

export const nomenclatureClientV2Url = (id: string): string =>
  `${NOMENCLATURE_CLIENT_V2_BASE}/${encodeURIComponent(id)}`;

export type TNomenclatureClientImage = {
  id: string;
  key: string;
  size: string;
  mime: string;
  createdAt?: string;
};

export type TNomenclatureClientBrand = {
  id: string;
  name: string;
};

export type TNomenclatureClientBarcode = {
  id: string;
  barcode: string;
};

export type TNomenclatureClientCharacteristic = {
  id: string;
  name: string;
  unit: string | null;
  value: string;
};

/** Элемент relatedProducts в ответе NomenclatureNormalizer (client). */
export type TNomenclatureClientRelatedEntry = {
  id: string;
  nomenclature: {
    id: string;
    article: string;
    brand: string;
    name: string;
    images: TNomenclatureClientImage[];
  };
};

export type TNomenclatureClient = {
  id: string;
  article: string;
  name: string;
  fixPrice?: number | null;
  brand: TNomenclatureClientBrand | null;
  size?: {
    width: number | null;
    height: number | null;
    length: number | null;
  };
  price: unknown[];
  weight: number;
  barcode: TNomenclatureClientBarcode[];
  images: TNomenclatureClientImage[];
  characteristicsValue: TNomenclatureClientCharacteristic[];
  productGroups: unknown[];
  relatedProducts: TNomenclatureClientRelatedEntry[];
  description: string | null;
};

export const getNomenclatureClient = async (
  id: string
): Promise<TNomenclatureClient> => {
  const res = await axiosInstance.get(nomenclatureClientV2Url(id));
  return res.data;
};

/** Алиас для совместимости со старым именем функции. */
export const getNomenclature = getNomenclatureClient;
